import './../assets/scss/Loader.scss';

const LoadingComponent = () => {
    return (
        <div className={`container-fluid z-3 position-fixed top-0 start-0 w-100 h-100 bg-inherit overflow-hidden`}>
            <div className="loader"></div>
        </div>
    );
};

export default LoadingComponent;
